import React from 'react';

import DTCCBanner from '../dtcc-banner/dtcc-banner';
import ProductPromotions from '../product-promotions/product-promotions';

import { formatCurrency } from '../../shared/utils/format/format';

import { PromotionData } from '../../shared/types/graphql-types';
import { MapPrice } from '../../shared/types/product';
import { PageTypes } from '../../shared/constants/page-types';

import './product-promos-or-dtcc.scss';

interface ProductPromosOrDTCCProps {
  brand?: string;
  className?: string;
  combinedMapPrice: MapPrice;
  hasPromotions?: boolean;
  instantStrikethroughSavingsPerProduct?: number;
  onSignIn?: () => void;
  pageType?: keyof typeof PageTypes;
  productType?: string;
  promoLinkOnClick?: () => void;
  promotionData: Array<PromotionData>;
  showDtccBanner?: boolean;
  showDuration?: boolean;
  showLongDescription?: boolean;
  totalStrikethroughSavings?: number;
}

function ProductPromosOrDTCC(props: ProductPromosOrDTCCProps) {
  const {
    brand,
    className = '',
    combinedMapPrice,
    hasPromotions,
    instantStrikethroughSavingsPerProduct,
    onSignIn,
    pageType,
    productType,
    promoLinkOnClick,
    promotionData,
    showDtccBanner,
    showDuration,
    showLongDescription,
    totalStrikethroughSavings
  } = props;

  return hasPromotions || showDtccBanner ? (
    <aside className={`product-deals ${className}`} styleName="container">
      {hasPromotions && (
        <ProductPromotions
          brand={brand}
          instantStrikethroughSavingsPerProduct={
            instantStrikethroughSavingsPerProduct
          }
          onClick={promoLinkOnClick}
          onSignIn={onSignIn}
          productType={productType}
          promos={promotionData}
          showDuration={showDuration}
          showLongDescription={showLongDescription}
          totalStrikethroughSavings={totalStrikethroughSavings}
        />
      )}
      {showDtccBanner && (
        <DTCCBanner
          applyNowButtonId="prebuilt-package-product-block-apply-now"
          combinedMapPrice={combinedMapPrice}
          formattedValue={formatCurrency(combinedMapPrice?.price || 0)}
          pageType={pageType}
          value={combinedMapPrice?.price}
        />
      )}
    </aside>
  ) : null;
}

export default ProductPromosOrDTCC;
